import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import TooltipPrimary from "../../components/tooltips/TooltipPrimary";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BookIcon from "@mui/icons-material/Book";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useDispatch } from "react-redux";
import MenuOpenSharpIcon from "@mui/icons-material/MenuOpenSharp";
import { setTheme, toggleSidebar } from "../../redux/actions/styles";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import InterestsIcon from "@mui/icons-material/Interests";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";

const Sidebar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { outlet, table, section } = useParams();

  const { sidebarActive } = useSelector((state) => state.styles);
  const { activeOutlet } = useSelector((state) => state.config);

  const { darkTheme } = useSelector((state) => state.styles);

  const { cart } = useSelector((state) => state.checkout);

  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (darkTheme) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.removeItem("theme");
    }
  }, [darkTheme]);

  return (
    <div className={`sidebar ${sidebarActive ? "sidebar-active" : ""}`}>
      <div className="sidebar-toggle" onClick={() => dispatch(toggleSidebar(sidebarActive ? false : true))}>
        <MenuOpenSharpIcon fontSize="small" style={{ transform: "scaleX(-1)" }} />
      </div>
      <div className="menu">
        <div className="section">
          {activeOutlet ? (
            <TooltipPrimary text="Menu" align="right">
              <Link
                to={table ? `/${outlet}/${table}` : `/${outlet}`}
                className={`tab ${
                  pathname === `/${outlet}` ||
                  pathname === `/${outlet}/${table}` ||
                  pathname === `/${outlet}/section/${section}` ||
                  pathname === `/${outlet}/${table}/section/${section}`
                    ? "tab-active"
                    : ""
                }`}
              >
                <div className="icon">
                  <DashboardIcon />
                </div>
              </Link>
            </TooltipPrimary>
          ) : (
            <TooltipPrimary text="Outlets" align="right">
              <Link to="/" className={`tab ${pathname === "/outlets" ? "tab-active" : ""}`}>
                <div className="icon">
                  <DashboardIcon />
                </div>
              </Link>
            </TooltipPrimary>
          )}
          {/* <TooltipPrimary text="Reservations" align="right">
            <Link to="/reservations" className={`tab ${pathname === "/reservations" ? "tab-active" : ""}`}>
              <div className="icon">
                <BookIcon />
              </div>
            </Link>
          </TooltipPrimary> */}
          <TooltipPrimary text="Cart" align="right">
            <Link
              to={activeOutlet ? (table ? `/cart/${outlet}/${table}` : `/cart/${outlet}`) : "/cart"}
              className={`tab ${pathname.includes("/cart") ? "tab-active" : ""}`}
            >
              <div className="icon">
                <ShoppingCartIcon />
                {cart.length > 0 && <div className="badge">{cart.length}</div>}
              </div>
            </Link>
          </TooltipPrimary>
          {table && (
            <TooltipPrimary text="Orders" align="right">
              <Link
                to={
                  activeOutlet ? (table ? `/your-orders/${outlet}/${table}` : `/your-orders/${outlet}`) : "/your-orders"
                }
                className={`tab ${pathname.includes("/your-orders") ? "tab-active" : ""}`}
              >
                <div className="icon">
                  <RestaurantRoundedIcon />
                </div>
              </Link>
            </TooltipPrimary>
          )}

          <TooltipPrimary
            text={darkTheme ? "Light" : "Dark"}
            align="right"
            onClick={() => dispatch(setTheme(!darkTheme))}
          >
            <div className={`tab`}>
              <div className="icon">{darkTheme ? <LightModeIcon /> : <NightsStayIcon />}</div>
            </div>
          </TooltipPrimary>
        </div>
      </div>
      <div className="settings-tab">
        {isAuthenticated ? (
          <TooltipPrimary text="Manage" align="right">
            <Link
              to={
                activeOutlet
                  ? table
                    ? `/manage/${outlet}/${table}`
                    : outlet
                    ? `/manage/${outlet}`
                    : `/manage`
                  : "/manage"
              }
              className={`tab ${pathname === "/manage" || pathname === `/manage/${outlet}` ? "tab-active" : ""}`}
            >
              <div className="icon">
                <AppRegistrationIcon style={{ fontSize: "1.75rem" }} />
              </div>
            </Link>
          </TooltipPrimary>
        ) : (
          <TooltipPrimary text="More" align="right">
            <Link
              to={activeOutlet ? (table ? `/more/${outlet}/${table}` : `/more/${outlet}`) : "/more"}
              className={`tab ${pathname.includes("/more") ? "tab-active" : ""}`}
            >
              <div className="icon">
                <InterestsIcon />
              </div>
            </Link>
          </TooltipPrimary>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
